import React, { ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Form, Space, Input, Button } from '@fuxi/eevee-ui';
import { Rule } from 'antd/es/form';
import { EeveeIcon } from 'common-package/src/components';
import styles from './index.module.less';

const cx = classNames.bind(styles);

type Props = {
  type?: 'input' | 'textArea';
  defaultValue?: string;
  editText?: string;
  editIcon?: ReactNode;
  emptyContent?: ReactNode;
  validateRules?: Rule[];
  wrapperStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  textInputStyle?: React.CSSProperties;
  onSave?: (text: string) => Promise<any>;
};

const defaultEditIcon = <EeveeIcon name="zhanweibianji" style={{ marginRight: 4 }} />;

export const EditText = ({
  type = 'input',
  defaultValue = '',
  editText = '编辑',
  editIcon = defaultEditIcon,
  emptyContent = '-',
  validateRules,
  wrapperStyle,
  textStyle,
  textInputStyle,
  onSave,
}: Props) => {
  const [form] = Form.useForm();
  const [value, setValue] = useState(defaultValue);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const toggleEdit = () => {
    setIsEdit(edit => !edit);
  };

  const handleEdit = () => {
    form.setFieldsValue({
      text: value,
    });
    toggleEdit();
  };

  const handleSubmit = async () => {
    const { text } = await form.validateFields();
    setLoading(true);
    await onSave?.(text);
    setLoading(false);
    setValue(text);
    toggleEdit();
  };

  return (
    <div className={cx('edit-text-wrapper')} style={wrapperStyle}>
      {isEdit ? (
        <Space size={10} align="start">
          <Form form={form}>
            <div className={cx('edit-text-input')} style={textInputStyle}>
              <Form.Item name="text" validateFirst rules={validateRules}>
                {type === 'input' ? <Input /> : <Input.TextArea autoSize allowClear />}
              </Form.Item>
            </div>
          </Form>
          <Button type="primary" onClick={handleSubmit} loading={loading}>
            保存
          </Button>
          <Button onClick={toggleEdit}>取消</Button>
        </Space>
      ) : (
        <div>
          <span className={cx('text')} style={textStyle}>
            {value || emptyContent}
          </span>
          <span onClick={handleEdit} className={cx('edit-btn')}>
            {editIcon}
            {editText}
          </span>
        </div>
      )}
    </div>
  );
};

export default EditText;
